var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selector-option second-level",class:{ 
        'selector-option--disabled': _vm.checkOptionDisabled(), 
        'selector-option--fake': _vm.secondLevelOption.isFake
    },on:{"mouseenter":function($event){_vm.showDisabledReason()},"mouseleave":function($event){_vm.hideDisabledReason()},"click":function($event){_vm.emitClick()}}},[_vm._v(_vm._s(_vm.labelToShow))])}
var staticRenderFns = []

export { render, staticRenderFns }